export default "__VITE_PUBLIC_ASSET__848298c9__"